export default "__VITE_ASSET__j6LdLG9X__"